import { STORAGE_KEY } from '@/constants/storage';
import { $http } from '@/plugins/common/http';
import { generateSignature } from '@/utils/utils';

export const changePassword = (data) => {
    return $http.patch('/users/password', data);
};

export const setUserLocale = (localeCode) => {
    return $http.patch('/users/locale', {
        localeCode,
    });
};

export const sendEmailOTP = () => {
    return $http.get(`/user/otp/send-email`);
};

export const verifyEmailOTP = (data) => {
    return $http.patch('/users/verify-email', data);
};

export const isEnoughBillingInfo = () => {
    return $http.get('/users/check-info');
};

export const saveSessionLog = () => {
    return $http.post('/users/session-log');
};

export const verifyTwoFALogin = (data) => {
    return $http.post('/users/login/2fa/verify', data);
};

export const setFirstChangePassword = (data) => {
    return $http.patch('/users/password/force', data);
};

export const changeEmail = (userId, data) => {
    return $http.patch('/users/email', data);
};

export const changeEmailOTP = () => {
    return $http.get(`/user/otp/change-email`);
};

export const getAuthNonce = () => {
    return $http.get(`/users/oauth/nonce`, {
        headers: {
            [STORAGE_KEY.SIGNATURE]: generateSignature(),
        },
    });
};

export const verifyGoogleAccount = (data) => {
    return $http.post('/users/google/callback', data);
};

export const getLinkGoogleAccountOtpCode = () => {
    return $http.get(`/user/otp/link-google-account`);
};

export const connectGoogleAccount = (data) => {
    return $http.post('/user/linked-accounts/google', data);
};

export const validateOtpConnectGoogleAccount = (data) => {
    return $http.post('/user/linked-accounts/google/validate-otp', data);
};

export const getLinkedAccounts = () => {
    return $http.get('/user/linked-accounts');
};

export const unLinkGoogleAccounts = (linkedAccountId) => {
    return $http.delete(`/user/linked-accounts/google/${linkedAccountId}`);
};

export const getReminders = () => {
    return $http.get('/users/reminders');
};
